import { memo } from 'react';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const RightArrow = ({ width, ...rest }: IconWrapperProps) => (
  <IconWrapper width={width || '20px'} viewBox="0 0 24 24" {...rest}>
    <path
      fill="currentColor"
      d="M20.71,12.71l-7,7a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L17.59,13H3a1,1,0,0,1,0-2H17.59l-5.3-5.29a1,1,0,0,1,1.42-1.42l7,7a1,1,0,0,1,.21.33,1,1,0,0,1,0,.76A1,1,0,0,1,20.71,12.71Z"
    />
  </IconWrapper>
);

export default memo(RightArrow);
